"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleStore = void 0;
const mobx_1 = require("mobx");
const shared_1 = require("@repo/shared");
function isLocale(value) {
    return typeof value === 'string' && shared_1.SUPPORTED_LOCALES.includes(value);
}
class LocaleStore {
    driver;
    locale = shared_1.DEFAULT_LOCALE;
    constructor(driver) {
        this.driver = driver;
        (0, mobx_1.makeAutoObservable)(this, { driver: false });
        if (driver) {
            const cached = driver.get();
            if (isLocale(cached)) {
                this.locale = cached;
            }
        }
    }
    setLocale(locale) {
        this.locale = locale;
        this.driver?.set(locale);
    }
}
exports.LocaleStore = LocaleStore;
//# sourceMappingURL=locale-store.js.map